import React ,{ PropTypes } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';


class CatCta extends React.PureComponent{
  static propTypes = {
    cta: PropTypes.object,
    lang: PropTypes.string,
    restSlug: PropTypes.string
  };

  render() {
    let isEmpty = require('lodash.isempty');
    return(
      <div className="cta-item">
        <div className="cta-thumb">
          <img src={this.props.cta.image} alt={this.props.cta.name} />
        </div>
        <div className="cta-item-info">
          <FormattedMessage id="cta_title">
            {(message) => <h5 className="cta-item-title">{message}{/*this.props.cta.name*/}</h5>}
          </FormattedMessage>
          {!isEmpty(this.props.cta) ?
            <Link className="cta-btn" to={'/' + this.props.lang + '/' + this.props.restSlug +
            '/items/' + this.props.cta.slug + '-' + this.props.cta.id + '/'}>
              <span>{this.props.cta.name}</span>
            </Link>
          :null
          }
        </div>
      </div>
    );
  }
}

export default CatCta;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/CatCta.js
 **/